import './Loading.css';
import { useState } from 'react';
import logo from '../../imgs/logo-eqg-white.svg'
import loading from '../../imgs/loading-2.gif'

function Loading() {
    return (
        <div className='containerLoading'>
            <img className='llog' alt='logo eu quero grana' src={logo} />
            Carregando, aguarde.
            <img className='carregando' alt='carregando' src={loading} />
        </div>
    );
}

export default Loading;